import React from 'react';
import { AppButton, Box, useFormContext, useWatch } from '@common-fe/common-fe';

import { PayoutDefinitionField, PayoutDefinitionFormValues } from '../../../PayoutDefinitionSetup.types';
import { usePayoutOrderModalsStore } from '../stores/usePayoutOrderModals.store';

import { MAX_COLUMNS_COUNT } from './PayoutOrder.constants';

interface PayoutOrderHeaderActionsProps {
  isEditMode: boolean;
  hasServices: boolean;
  hasAnyPlanSelected?: boolean;
}

/**
 * Header actions for the Payout Order BlockWrapper.
 * Uses react-hook-form context for column state and zustand for modals.
 */
const PayoutOrderHeaderActions: React.FC<PayoutOrderHeaderActionsProps> = ({
  isEditMode,
  hasServices,
  hasAnyPlanSelected,
}) => {
  const { setValue } = useFormContext<PayoutDefinitionFormValues>();
  const columnsCount = useWatch<PayoutDefinitionFormValues, PayoutDefinitionField.columnsCount>({
    name: PayoutDefinitionField.columnsCount,
  });
  const canAddColumn = columnsCount < MAX_COLUMNS_COUNT;

  const openAddServiceModal = usePayoutOrderModalsStore((service) => service.openAddServiceModal);
  const openClearAllModal = usePayoutOrderModalsStore((service) => service.openClearAllModal);

  const handleAddColumn = () => {
    setValue(PayoutDefinitionField.columnsCount, Math.min(columnsCount + 1, MAX_COLUMNS_COUNT), {
      shouldDirty: true,
    });
  };

  if (!isEditMode) return null;

  return (
    <Box direction="row" align="center" gap="spacing12">
      <AppButton
        testId="payout-order_clear-all-button"
        buttonType="secondary"
        color="red"
        width="130px"
        disabled={!hasAnyPlanSelected}
        onClick={openClearAllModal}
      >
        Clear All
      </AppButton>
      <AppButton
        testId="payout-order_add-column-button"
        buttonType="secondary"
        width="130px"
        disabled={!canAddColumn || !hasServices}
        onClick={handleAddColumn}
      >
        Add Column
      </AppButton>
      <AppButton
        testId="payout-order_add-service-button"
        buttonType="secondary"
        width="130px"
        onClick={openAddServiceModal}
      >
        Add Service
      </AppButton>
    </Box>
  );
};

export default PayoutOrderHeaderActions;
